<div class="column activity-container">
    <div class="row margin-30px" *ngIf="classDetail">
        <img width="20%" height="150px" *ngIf="classDetail.ImageData"
            [src]="classDetail.ImageData? 'data:image/png;base64,'+classDetail.ImageData : 'data:image/png;base64,'+classDetail.bannerImage" />
        <section class="class-info__detail" [ngClass]="{'w-100 ms-0' : !classDetail.ImageData}">
            <div class="class-info__detail--header">
                <div class="class-info__detail--header-left">
                    <h1 class="class-info__detail__name">{{classDetail.LessonName}}</h1>
                    <div class="class-info__detail__location">
                        <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
                        &nbsp;<span>{{classDetail.LocationName}}</span>
                    </div>
                </div>
                <div class="class-info__detail--header-right" *ngIf="classDetail.BaseRate">
                    <label for="rate" class="class-info__detail__rate-label">{{'Startingfrom' | translate}}</label>
                    <div class="class-info__detail__rate-value">{{operatingCurrency}} {{classDetail.BaseRate | currencyDecimalFormatter}}</div>
                </div>
            </div>
            <div class="class-info__detail--content">
                <div class="class-info__detail__item">
                    <label for="start-date" class="class-info__detail__item--label">{{'startDate' | translate}}</label>
                    <div class="class-info__detail__item--value">{{classDetail.StartDate | date:'MM/dd/yyyy'}}</div>
                </div>
                <div class="class-info__detail__item">
                    <label for="endDate" class="class-info__detail__item--label">{{'endDate' | translate}}</label>
                    <div class="class-info__detail__item--value">{{classDetail.EndDate | date:'MM/dd/yyyy'}}</div>
                </div>
                <div class="class-info__detail__item class-info__detail__item_last">
                    <label for="instructor" class="class-info__detail__item--label">{{'Instructor' | translate}}</label>
                    <div class="class-info__detail__item--value">{{classDetail.Staffs}}</div>
                </div>
            </div>
        </section>
    </div>

    <div class="activity___selector_content">
        <div class="row m-0 activity-selector">
            <div class="reservation-pannel col-lg-5 col-md-5 column">

                <div class="instructor row">
                    <div class="dy-date-picker col-lg-5 col-md-5">
                        <dynamic-form [config]="reservationConfig" #form="dynamicForm">
                        </dynamic-form>
                    </div>
                    <div class="dy-date-picker col-lg-5 col-md-5">
                        <dynamic-form [config]="locationConfig" #form="dynamicForm">
                        </dynamic-form>
                    </div>
                </div>
                <div class="instructor row">
                    <div class="dy-date-picker  col-lg-5 col-md-5">
                        <div class="txt-bold">
                            {{'SelectDates' | translate}}
                        </div>

                        <div class="dy-date-picker from-date">
                            <dynamic-form [config]="from_dateConfig" #form="dynamicForm">
                            </dynamic-form>
                        </div>

                    </div>
                    <div class="dy-date-picker  col-lg-5 col-md-5">
                        <div class="txt-bold">
                            {{'selectCoverSize' | translate}}
                        </div>
                        <div class="txt-sub-title">
                            {{'NoofStudents' | translate}}
                        </div>
                        <div class="stu-count">
                            <div class="count">
                                <dynamic-form [config]="customizeSizeConfig" #form="dynamicForm">
                                </dynamic-form>
                                <span class="custom-error" *ngIf="!validGroupSize">{{'MisMatchGroupSizeWithClass' | translate}}</span>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="cover-size-field">

                    <div class="booking-type" *ngIf="bookingTypeConfig && bookingTypeConfig.length">
                        <div class="txt-bold">
                            {{'SelectBookingTypes' | translate}}
                        </div>
                        <div class="bookingtypes-list col-lg-5 col-md-5">
                            <dynamic-form [config]="bookingTypeConfig" #form="dynamicForm">
                            </dynamic-form>
                            <span class="custom-error" *ngIf="!validBookingTypes">{{'MisMatchBookingTypeWithBookingSize'
                                |
                                translate}}</span>
                        </div>
                    </div>
                    <div class="cover-type" *ngIf="coverTypeConfig && coverTypeConfig.length">
                        <div class="txt-bold">
                            {{'SelectCoverTypes' | translate}}
                        </div>
                        <div class="cover-list col-lg-5 col-md-5">
                            <dynamic-form [config]="coverTypeConfig" #form="dynamicForm">
                            </dynamic-form>
                            <span class="custom-error" *ngIf="!validCoverTypes">{{'MisMatchCoverTypeWithBookingSize' |
                                translate}}</span>
                        </div>
                    </div>

                </div>

            </div>
            <div class="slots col-lg-7 col-md-7">
                <div class="open-slot-container">
                    <div class="no-slot"
                        *ngIf="activityService.slots_holder && activityService.slots_holder.length === 0">
                        {{'noslots' | translate}}
                    </div>
                    <div *ngIf="activityService.slots_holder && activityService.slots_holder.length">
                        <div class="open-slot-container__header-container">
                            <div class='open-slot-container__header'>{{'availableSlots' | translate}}</div>
                            <div class="open-slot-container__legends" *ngIf="classDetail?.MinDuration">
                                <div class="open-slot-container__legends-text">
                                    <span>{{'minDurationMins' |
                                        translate}}
                                    </span>&nbsp;:&nbsp;<span
                                        class="open-slot-container__header">{{classDetail.MinDuration}}</span>
                                </div>
                                <div class="open-slot-container__legends-text">
                                    <span>{{'maxDurationMins' |
                                        translate}}</span>&nbsp;:&nbsp;<span
                                        class="open-slot-container__header">{{classDetail.MaxDuration}}</span>
                                </div>
                            </div>
                        </div>
                        <app-open-booking-slot-view (SlotChanged)="checkFormValidity()"
                            [minDuration]="classDetail?.MinDuration" [maxDuration]="classDetail?.MaxDuration"
                            [allAvailableSlots]="availableSlots">
                        </app-open-booking-slot-view>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="row button-container pre-next">
        <div class="button-group">
            <div class="d-inline-block button-gap" *ngIf="activityService.operation == Operation.create">
                <app-button [buttontype]="previousButton" (valueChange)="gotoPreviousPage($event)"></app-button>
            </div>
            <div class="d-inline-block button-gap">
                <app-button [buttontype]="nextButton" (valueChange)="gotoNextPage($event)"></app-button>
            </div>
        </div>
    </div>
</div>